import Crud from '../views/Involved/Crud'
import Entity from '../views/Involved/Add'

let routes = {
    path: '/involveds',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/involveds/add',
            name: 'NewInvolved',
            component: Entity,
            meta: {
                pageTitle: 'Envolvido',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Envolvido',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/involveds/edit/:id?',
            name: 'EditInvolved',
            component: Entity,
            meta: {
                pageTitle: 'Envolvido',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Envolvido',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/involveds',
            name: 'list-involveds',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Envolvidos',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Envolvidos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
